module.exports = __webpack_public_path__ + "static/media/fig_28.891e0dc5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_28.jpg
// module id = 667
// module chunks = 0